import { X, Check } from 'lucide-react';

const PERKS = [
  'Hard Mode challenges (2x–3x points)',
  'Challenge Lab voting rights',
  'Custom challenge creation',
  'Exclusive SENT IT badge',
  'Priority in community vote queue',
];

export const PremiumUpgradeModal = ({ isOpen, onClose, accountEmail }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
      style={{ background: 'rgba(0,0,0,0.92)' }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div
        className="relative w-full max-w-md bg-black border-2 border-yellow-500 p-6 sm:p-8"
        style={{ boxShadow: '0 0 60px rgba(234,179,8,0.35)' }}
      >
        {/* Close */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-600 hover:text-yellow-400 transition-colors touch-manipulation"
        >
          <X size={20} />
        </button>

        {/* Heading */}
        <div className="text-center mb-6">
          <div className="inline-block bg-yellow-500 px-3 py-1 mb-3">
            <span className="text-black font-black text-xs uppercase tracking-widest">PREMIUM</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-black text-yellow-400 uppercase tracking-tight leading-none mb-2">
            SENDIT PASS
          </h2>
          <p className="text-gray-300 font-bold text-base uppercase tracking-wide">
            Stop overthinking whether to buy it.
          </p>
        </div>

        {/* Price */}
        <div className="text-center border-y-2 border-yellow-600 py-4 mb-6">
          <span className="text-3xl sm:text-4xl font-black text-white">$29.99</span>
          <span className="text-yellow-400 font-black text-sm uppercase ml-2">— once — forever</span>
        </div>

        {/* Perks */}
        <ul className="space-y-2.5 mb-6">
          {PERKS.map((perk) => (
            <li key={perk} className="flex items-start gap-3">
              <Check size={16} className="text-yellow-400 flex-shrink-0 mt-0.5" />
              <span className="text-white font-bold text-sm uppercase tracking-wide">{perk}</span>
            </li>
          ))}
        </ul>

        {/* CTA */}
        <a
          href="https://whytebread.gumroad.com/l/senditpass"
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full text-center bg-yellow-500 hover:bg-yellow-400 text-black font-black text-lg uppercase tracking-widest py-4 border-2 border-yellow-300 transition-all active:scale-95 touch-manipulation mb-3"
          style={{ boxShadow: '0 0 24px rgba(234,179,8,0.6)' }}
        >
          JUST SEND IT →
        </a>
        <p className="text-center text-gray-600 font-bold text-xs uppercase tracking-wide">
          Checkout with {accountEmail}. One payment. Return here and refresh after purchase.
        </p>
      </div>
    </div>
  );
};
